import { useQuery } from "@tanstack/react-query";

import { getReportScopes, ReportScope } from "@services/reportEngine";

export const useReportScopes = () =>
  useQuery<ReportScope[]>(["reportScopes"], getReportScopes, {
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
